import React from 'react'

const Footer = () => {
  return (
    // <!--==================== FOOTER SECTION ====================-->

    <section className="footer">

      <div className="footer__container">
        <img src="images/footer_transparent.png" alt="Five little stonies holding hands denoting the end of the page"
          className="footer__image" />
      </div>

      <div className="copyright">
        {/* <p>Copyright &copy; 2024 Little Stonies. All Rights Reserved. Art by: Valeriia Potaichuk </p> */}
        <p>Copyright &copy; 2024 Little Stonies. All Rights Reserved. Designed by: ObsidienDev</p>
      </div>
    </section>
  )
}

export default Footer;